import React from "react";
import { Switch, Redirect } from "react-router-dom";
import TopMenu from "Components/TopMenu/TopMenu";
import { superToolsMenuItems } from "Constants/superToolsMenuItems";
import SuperRoute from "hoc/Routes/SuperRoute/SuperRoute";
import DiscountCard from "./components/DiscountCard/DiscountCard";
import IncCredit from "./components/IncCredit/IncCredit";
import IncTime from "./components/IncTime/IncTime";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";

export default function ToolsIndex() {
  const { t } = useTranslation();
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));
  let topMenuItems = [...superToolsMenuItems];
  topMenuItems.map((item) => {
    if (item.menu_title === "incCredit") {
      item.active = !!read("FormManualCredit");
      return null;
    }
    if (item.menu_title === "incTime") {
      item.active = !!read("FormIncTime");
      return null;
    }
    if (item.menu_title === "discountCard") {
      item.active = !!read("FormDiscount");
      return null;
    }
  });

  return (
    <>
      <TopMenu menuItems={topMenuItems.filter((item) => item.active)} />
      <Switch>
        <Redirect
          exact
          from="/admin/tools"
          to={
            read("FormDiscount") ? "/admin/tools/discountCard"
            : read("FormIncTime") ? "/admin/tools/incTime"
            : read("FormManualCredit") ? "/admin/tools/incCredit"
            : "/admin"
          }
        />
        <SuperRoute
          exact
          path="/admin/tools/discountCard"
          component={DiscountCard}
          isLoggedIn={isLoggedIn}
        />
        <SuperRoute
          exact
          path="/admin/tools/incTime"
          component={IncTime}
          isLoggedIn={isLoggedIn}
        />
        <SuperRoute
          exact
          path="/admin/tools/incCredit"
          component={IncCredit}
          isLoggedIn={isLoggedIn}
        />
      </Switch>
    </>
  );
}
